<script>
  import { availableFacets, hasAppliedFacets, selectedFacets } from "./stores/facets-store.js";
  import { productCount } from "./stores/collection-products-store.js";
  import handleize from "../../utils/handleize.js";
  import { onMount } from "svelte";
  import { getResults } from "../../modules/searchanise";
  import CollectionSort from "./CollectionSort.svelte";
  import EVENT from "../../enums/event.js";
  import dispatchEvent from "../../utils/dispatch-event.js";

  export let collection;
  export let query;

  let filtersShowing = false;
  let localSelected = [];

  async function getFacets() {
    return await getResults({
      collection: collection?.handle || null,
      maxResults: 500,
      items: false,
      q: query
    }).then(data => {
      availableFacets.set(data.facets
        .filter(filter => filter.attribute !== "price")
      );
    });
  }

  function handleCheckboxToggle(e) {
    selectedFacets.toggle(...e.target.getAttribute("value").split("::"));
  }

  function resetSelectedFacets() {
    selectedFacets.set({});
    localSelected = [];
    filtersShowing = false;
  }

  function toggleFiltersDisplay() {
    filtersShowing = !filtersShowing;

    if (window.matchMedia("(max-width: 1024px)").matches) {
      dispatchEvent(filtersShowing ? EVENT.FILTERS.FILTER_LIST_OPENED : EVENT.FILTERS.FILTER_LIST_CLOSED, document);
    }
  }

  onMount(() => {
    document.querySelector("[data-ghost=\"facets\"]")?.remove();
  });

  let facetsPromise = getFacets();
</script>

<div class="relative">
  <div class="wrapper flex justify-between items-center bg-white">
    <div class="flex items-center">
      <button
        class="
          btn uppercase pl-3 pr-2
          mr-3
          flex
          {filtersShowing ? 'btn-brand-electric' : 'btn-brand-gray'}
        "
        on:click="{toggleFiltersDisplay}"
      >
        <span class="inline-block w-6 mr-1 flex items-center">
          {#if filtersShowing}
            Apply
          {:else}
            Filters
          {/if}
        </span>

        <span class="w-2 h-2 flex">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24"
               class="w-full h-full"
               xml:space="preserve"><g fill="currentColor"><path d="M23.4 11.4h-1.3v-2h-5.2v2H.6a.6.6 0 0 0 0 1.2h16.3v2h5.2v-2h1.3a.6.6 0 0 0 0-1.2zm-2.5 2.001h-2.8V10.6h2.8v2.801zM23.4 5.4H8.1v-2H2.9v2H.6a.6.6 0 0 0 0 1.2h2.3v2h5.2v-2h15.3a.6.6 0 1 0 0-1.2zm-16.5 2H4.1V4.6h2.8v2.8zM23.4 17.401H11.1v-2H5.9v2H.6a.6.6 0 1 0 0 1.2h5.3v2h5.2v-2h12.3a.6.6 0 0 0 0-1.2zm-13.5 2H7.1V16.6h2.8v2.801z"/></g></svg>
        </span>
      </button>

      <p
        class="
          mr-2 b5 font-medium lg:block
          {filtersShowing ? '' : 'hidden'}
        "
      >
        {$productCount} items
      </p>

      {#if $hasAppliedFacets}
        <button
          class="underline b5 lg:block {filtersShowing ? '' : 'hidden'}"
          on:click={resetSelectedFacets}
        >
          Reset
        </button>
      {/if}
    </div>
    <div
      class="lg:block"
      class:hidden={filtersShowing}
    >
      <CollectionSort collection={collection} />
    </div>
  </div>

  <div
    class="
      px-2/24 pt-2 pb-5
      absolute z-40 bg-white w-full
      overflow-y-scroll overscroll-contain
      transition-all duration-250
      max-h-[75vh]
      shadow-inner lg:shadow-md
    "
    class:hidden="{!filtersShowing}"
    data-filters-menu
  >
    <button class="sticky top-2.5 left-full inline-block w-2 h-2" on:click={toggleFiltersDisplay}>
      <svg version="1.1" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <g id="Cross" transform="translate(-5.001,-5)" clip-path="url(#clip-Cross)">
          <g transform="translate(14988 19854)" fill="none" stroke="currentColor" stroke-linecap="round"
             stroke-width="2">
            <line transform="translate(-14982 -19848)" x1="12" y2="12" data-name="Line 197" />
            <line transform="translate(-14982 -19848)" x2="12" y2="12" data-name="Line 198" />
          </g>
        </g>
      </svg>
    </button>

    <div class="grid grid-cols-1 lg:grid-cols-4">
      {#await facetsPromise then data}
        {#each $availableFacets as facet}
          <div class="mb-4">
            <p class="b4 font-bold uppercase mb-1">
              {facet.title}
            </p>
            <ul>
              {#each facet.buckets as option}
                <li>
                  <input
                    type="checkbox"
                    class="mr-1"
                    on:click={handleCheckboxToggle}
                    bind:group={localSelected}
                    id="{`facets_${facet.attribute}_${handleize(option.value)}`}"
                    name="{facet.attribute}"
                    value="{`${facet.attribute}::${option.value}`}"
                  >

                  <label
                    class="cursor-pointer b4"
                    for="{`facets_${facet.attribute}_${handleize(option.value)}`}"
                  >
                    {option.value}
                  </label>
                </li>
              {/each}
            </ul>
          </div>
        {/each}
      {/await}
    </div>
  </div>
</div>
